/**
 * @generated SignedSource<<62db5c3df5d00591c6a5aa2a2f82e574>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PhotoType = "APPEAL" | "PROFILE" | "VERIFICATION" | "%future added value";
export type CreatePhotoInput = {
  clientMutationId?: string | null | undefined;
  photo: PhotoInput;
};
export type PhotoInput = {
  description?: string | null | undefined;
  sequence?: number | null | undefined;
  storageObjectId: any;
  type: PhotoType;
};
export type useVerificationPhotosCreatePhotoMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreatePhotoInput;
};
export type useVerificationPhotosCreatePhotoMutation$data = {
  readonly createPhoto: {
    readonly photoEdge: {
      readonly cursor: any | null | undefined;
      readonly node: {
        readonly createdAt: any;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly rowId: any;
        readonly sequence: number;
        readonly storageObject: {
          readonly blurhash: string | null | undefined;
          readonly bucket: string | null | undefined;
          readonly key: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useVerificationPhotosCreatePhotoMutation = {
  response: useVerificationPhotosCreatePhotoMutation$data;
  variables: useVerificationPhotosCreatePhotoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "SEQUENCE_ASC"
    ]
  }
],
v3 = {
  "alias": null,
  "args": (v2/*:: as any*/),
  "concreteType": "PhotoEdge",
  "kind": "LinkedField",
  "name": "photoEdge",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sequence",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StorageObject",
          "kind": "LinkedField",
          "name": "storageObject",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "blurhash",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bucket",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "photoEdge(orderBy:[\"SEQUENCE_ASC\"])"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useVerificationPhotosCreatePhotoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreatePhotoPayload",
        "kind": "LinkedField",
        "name": "createPhoto",
        "plural": false,
        "selections": [
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useVerificationPhotosCreatePhotoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreatePhotoPayload",
        "kind": "LinkedField",
        "name": "createPhoto",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": (v2/*:: as any*/),
            "filters": null,
            "handle": "appendEdge",
            "key": "",
            "kind": "LinkedHandle",
            "name": "photoEdge",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "325709114b271daba5d0a02e916370fc",
    "id": null,
    "metadata": {},
    "name": "useVerificationPhotosCreatePhotoMutation",
    "operationKind": "mutation",
    "text": "mutation useVerificationPhotosCreatePhotoMutation(\n  $input: CreatePhotoInput!\n) {\n  createPhoto(input: $input) {\n    photoEdge(orderBy: [SEQUENCE_ASC]) {\n      cursor\n      node {\n        createdAt\n        description\n        id\n        rowId\n        sequence\n        storageObject {\n          blurhash\n          bucket\n          key\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5cf2a35af4f57f7763a5eb612db205c2";

export default node;
